// LeaderboardManager: submit scores and fetch top lists.
// Remote-first when configured, with the local board as an offline cache so a
// network blip never loses a score.

import { LocalLeaderboard } from './adapters/localLeaderboard.js';
import { RemoteLeaderboard } from './adapters/remoteLeaderboard.js';
import { SupabaseLeaderboard } from './adapters/supabaseLeaderboard.js';

export class LeaderboardManager {
  constructor(cfg, ctx, storage) {
    this.log = ctx.log;
    this.local = new LocalLeaderboard(storage, cfg.maxLocalEntries);
    if (cfg.adapter === 'supabase') {
      this.remote = new SupabaseLeaderboard(ctx.backend);
    } else {
      const useRemote = (cfg.adapter === 'remote') || (cfg.adapter === 'auto' && cfg.remote);
      this.remote = useRemote && cfg.remote ? new RemoteLeaderboard(cfg.remote) : null;
    }
  }

  async submit(boardId, entry) {
    // Always record locally.
    const localResult = await this.local.submit(boardId, entry);
    if (this.remote) {
      try {
        const r = await this.remote.submit(boardId, entry);
        return { ...r, local: localResult, source: 'remote' };
      } catch (err) {
        this.log.warn('Remote leaderboard submit failed; kept local.', err);
      }
    }
    return { ...localResult, source: 'local' };
  }

  async top(boardId, limit = 10) {
    if (this.remote) {
      try {
        return { entries: await this.remote.top(boardId, limit), source: 'remote' };
      } catch (err) {
        this.log.warn('Remote leaderboard fetch failed; using local cache.', err);
      }
    }
    return { entries: await this.local.top(boardId, limit), source: 'local' };
  }
}
